import { Award, Users, Target, MessageCircle, FileText, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import React from "react";
import { Helmet } from "react-helmet";

export const AboutPage = () => {
  return (
    <div className="h-full overflow-auto px-4 py-8">
      <Helmet>
        <title>Sakshatkar AI About Page</title>
        <meta
          name="Sakshatkar AI About Page<"
          content="Learn more about Sakshatkar AI, an AI-powered interview simulator that helps you practice technical interviews and get personalized feedback to improve your performance."
        />
        <meta property="og:title" content="Sakshatkar AI About Page" />
      </Helmet>
      <div className="max-w-4xl mx-auto space-y-12">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center space-y-6"
        >
          <h1 className="text-4xl font-bold text-white">
            Revolutionizing Interview Preparation
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            AI Interviewer helps developers prepare for technical interviews
            through personalized, AI-powered practice sessions.
          </p>
        </motion.div>

        {/* Mission Cards */}
        <div className="grid gap-8 md:grid-cols-3">
          {[
            {
              icon: Target,
              title: "Our Mission",
              description:
                "To make interview preparation accessible, effective, and stress-free for developers worldwide.",
            },
            {
              icon: Users,
              title: "Who We Serve",
              description:
                "From junior developers to senior engineers, we help tech professionals at every career stage.",
            },
            {
              icon: Award,
              title: "Our Approach",
              description:
                "Combining AI technology with industry expertise to deliver realistic interview experiences.",
            },
          ].map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="p-6 rounded-xl backdrop-blur-xl border border-gray-700/50 bg-gray-800/30"
            >
              <div className="p-2 w-fit rounded-lg bg-gradient-to-r from-blue-500 to-cyan-400">
                <item.icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-white">
                {item.title}
              </h3>
              <p className="mt-2 text-gray-400">{item.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Additional Info */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="prose prose-invert max-w-none"
        >
          <h2 className="text-2xl font-bold text-white">How It Works</h2>
          <p className="text-gray-400">
            Our AI-powered platform simulates real interview scenarios,
            providing instant feedback and personalized recommendations. We
            analyze your responses, communication style, and technical accuracy
            to help you improve your interview skills.
          </p>

          <h2 className="text-2xl font-bold text-white mt-8">Why Choose Us</h2>
          <ul className="text-gray-400 list-disc pl-6 space-y-2">
            <li>Realistic interview simulations</li>
            <li>Personalized feedback and coaching</li>
            <li>Comprehensive technical coverage</li>
            <li><span className="text-green-400 font-medium">Resume Chat</span> - AI-powered resume enhancement through conversation</li>
            <li>Flexible practice schedule</li>
            <li>Progress tracking and analytics</li>
          </ul>
        </motion.div>
      </div>
    </div>
  );
};
